import React, { useState, useEffect } from 'react';
import '../assets/css/packageconfirmation.css';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import { withStyles } from "@material-ui/core/styles";
import Footer from '../components/FooterComponent';
import TermsOfUseContent from './SelfFundTermsOfUseContent';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useHistory } from 'react-router-dom';
import queryString from 'query-string';
import Header from '../components/HeaderComponent';

function loadScript(src) {
    return new Promise((resolve) => {
        const script = document.createElement('script');
        script.src = src;
        script.onload = () => resolve(true);
        script.onerror = () => resolve(false);
        document.body.appendChild(script);
    });
}

const SelfFundComponent = (props) => {
    const { classes } = props;
    const history = useHistory();
    const [audId, setAudId] = useState(null);
    const [userData, setUserData] = useState(null);
    const [packageData, setPackageData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [userDataError, setUserDataError] = useState(null);
    const [paymentLoading, setPaymentLoading] = useState(false);
    const [paymentStatus, setPaymentStatus] = useState(null);
    const [productTermsAccepted, setProductTermsAccepted] = useState(false);
    const [medibuddyTermsAccepted, setMedibuddyTermsAccepted] = useState(false);
    const [showProductTermsModal, setShowProductTermsModal] = useState(false);
    const [showMedibuddyTermsModal, setShowMedibuddyTermsModal] = useState(false);
    const [member1, setMember1] = useState({ name: '', phone: '', dob: '', relationship: '' });
    const [member2, setMember2] = useState({ name: '', phone: '', dob: '', relationship: '' });
    const [showMember3, setShowMember3] = useState(false);
    const [showMember4, setShowMember4] = useState(false);
    const [member3, setMember3] = useState({ name: '', phone: '', dob: '', relationship: '' });
    const [member4, setMember4] = useState({ name: '', phone: '', dob: '', relationship: '' });

    const getBaseUrl = () => {
        if (window.location.hostname === 'localhost') {
            return 'https://affinity.medibuddy.in';
        }
        return window.location.origin;
    };

    const getPaymentBaseUrl = () => {
        if (window.location.hostname === 'localhost') {
            return 'http://localhost:8080';
        }
        return window.location.origin;
    };

    useEffect(() => {
        const parsed = queryString.parse(window.location.search);
        const token = parsed.token;
        if (!token) {
            setError('Invalid link. Token not found.');
            setLoading(false);
            return;
        }

        resolveSMFGToken(token);
    }, []);

    const formatMemberDob = (dobString) => {
        if (!dobString) return 'N/A';
        const parts = dobString.split('/');
        if (parts.length === 3) {
            const day = parseInt(parts[0], 10);
            const month = parseInt(parts[1], 10) - 1;
            const year = parseInt(parts[2], 10);
            const date = new Date(year, month, day);
            if (!isNaN(date.getTime())) {
                return date.toLocaleDateString();
            }
        }
        const date = new Date(dobString);
        return !isNaN(date.getTime()) ? date.toLocaleDateString() : dobString;
    };

    const resolveSMFGToken = async (token) => {
        try {
            const response = await fetch(
                getBaseUrl() + '/patientswebapp/affinity/resolveSMFGToken',
                {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ token })
                }
            );
            const data = await response.json();

            if (data.success !== 1 || !data.data) {
                setError(data.error || 'Invalid or expired link. Please request a new link.');
                setLoading(false);
                return;
            }

            const dbData = data.data.userDetails;
            const pkgData = data.data.packageDetails;

            setAudId(dbData.id);
            setUserData(dbData);
            setPackageData(pkgData);
            setUserDataError(null);

            // Auto-fill Member 1 and Member 2 from database
            if (dbData.additionalMemberData) {
                try {
                    const members = JSON.parse(dbData.additionalMemberData);
                    if (Array.isArray(members)) {
                        if (members.length > 0) {
                            setMember1(members[0]);
                        }
                        if (members.length > 1) {
                            setMember2(members[1]);
                        }
                    }
                } catch (e) {
                   // console.log('Error parsing member data:', e);
                }
            }

            // Check if payment is already completed
            if (data.data.paymentCompleted) {
                setPaymentStatus('completed');
            }
        } catch (e) {
            setError('Error resolving link: ' + e.message);
        } finally {
            setLoading(false);
        }
    };

    const handlePayNow = async () => {
        if (!userData || !audId) {
            setError('User details not found');
            return;
        }

        if (paymentLoading) {
            return;
        }

        setPaymentLoading(true);
        setError(null);

        let popupOpened = false;

        try {
            const additionalMembers = [];
            if (showMember3 && member3.name) {
                additionalMembers.push(member3);
            }
            if (showMember4 && member4.name) {
                additionalMembers.push(member4);
            }

            const paymentLinkResponse = await fetch(getPaymentBaseUrl() + '/upsell/iho/createPaymentLink', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    packageId: userData?.packageId,
                    customerName: userData?.proposer_name,
                    phoneNumber: userData?.mobilenumber,
                    email: userData?.email,
                    audId: audId,
                    additionalMembers: additionalMembers
                })
            });
            const paymentLinkData = await paymentLinkResponse.json();
            //console.log('paymentLinkResponse:', paymentLinkResponse.status, paymentLinkData);

            if (!paymentLinkData.success || !paymentLinkData.data || !paymentLinkData.data.paymentLink) {
                setError(paymentLinkData.error || paymentLinkData.data?.message || paymentLinkData.message || 'Failed to create payment link.');
                return;
            }

            // Open payment link in popup
            const width = 500;
            const height = 600;
            const left = window.screenX + (window.outerWidth - width) / 2;
            const top = window.screenY + (window.outerHeight - height) / 2;
            
            const paymentWindow = window.open(
                paymentLinkData.data.paymentLink,
                'RazorpayPayment',
                `width=${width},height=${height},left=${left},top=${top}`
            );

            if (!paymentWindow) {
                setError('Popup blocked. Please allow popups and try again.');
                return;
            }

            popupOpened = true;

            // Monitor payment window for completion
            const checkWindow = setInterval(() => {
                if (paymentWindow.closed) {
                    clearInterval(checkWindow);
                    setPaymentLoading(false);
                    setPaymentStatus('pending');
                    // Redirect to status page with verified audId
                    setTimeout(() => {
                        history.push(`/smfg-status?audId=${audId}`);
                    }, 2000);
                }
            }, 500);

        } catch (e) {
            setError('Error creating payment link: ' + e.message);
        } finally {
            if (!popupOpened) {
                setPaymentLoading(false);
            }
        }
    };


    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <CircularProgress />
            </div>
        );
    }

    if (error) {
        return (
            <div>
                <Header />
                <Container maxWidth="sm" style={{ marginTop: '40px', textAlign: 'center' }}>
                    <h2 style={{ color: '#d32f2f' }}>Error</h2>
                    <p>{error}</p>
                </Container>
                <Footer />
            </div>
        );
    }

    // Show payment completed page if payment is already done
    if (paymentStatus === 'completed' && userData) {
        return (
            <div>
                <Header />
                <Container maxWidth="sm" style={{ marginTop: '40px', marginBottom: '40px' }}>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <div style={{ textAlign: 'center', padding: '40px 20px' }}>
                                <div style={{ fontSize: '60px', color: '#4caf50', marginBottom: '20px' }}>✓</div>
                                <h2 style={{ color: '#4caf50', marginBottom: '10px' }}>Payment Already Completed</h2>
                                <p style={{ color: '#666', fontSize: '16px', marginBottom: '30px' }}>
                                    Your payment has been successfully processed.
                                </p>
                            </div>
                        </Grid>
                        <Grid item xs={12}>
                            <div style={{ background: '#f5f5f5', padding: '20px', borderRadius: '8px', marginBottom: '20px' }}>
                                <h4>Customer Details</h4>
                                <p><strong>Name:</strong> {userData.proposer_name}</p>
                                <p><strong>Mobile:</strong> {userData.mobilenumber}</p>
                                {userData.email && <p><strong>Email:</strong> {userData.email}</p>}
                            </div>
                        </Grid>
                        <Grid item xs={12}>
                            <div style={{ background: '#e8f5e9', padding: '20px', borderRadius: '8px', marginBottom: '20px' }}>
                                <h4>Payment Details</h4>
                                {userData.transactionId && (
                                    <p><strong>Transaction ID:</strong> {userData.transactionId}</p>
                                )}
                                {userData.payment_date && (
                                    <p><strong>Payment Date:</strong> {new Date(userData.payment_date).toLocaleString()}</p>
                                )}
                                <p><strong>Amount:</strong> Rs. {userData.discountedPrice || 0}</p>
                                <p><strong>Status:</strong> <span style={{ color: '#4caf50', fontWeight: 'bold' }}>{userData.userStatus}</span></p>
                            </div>
                        </Grid>
                        <Grid item xs={12} style={{ textAlign: 'center' }}>
                            <button
                                onClick={() => history.push('/')}
                                style={{
                                    padding: '14px 40px',
                                    fontSize: '16px',
                                    backgroundColor: '#4caf50',
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: '6px',
                                    cursor: 'pointer',
                                    fontWeight: '600'
                                }}
                            >
                                Go to Home
                            </button>
                        </Grid>
                    </Grid>
                </Container>
                <Footer />
            </div>
        );
    }

    return (
        <div className="confirmation">
            <Header />
            <Container maxWidth="lg" style={{ paddingTop: '20px', paddingBottom: '20px' }}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={12}>
                        <div style={{ padding: '15px', backgroundColor: '#fff', borderRadius: '4px', border: '1px solid #e0e0e0' }}>
                            {/* Warning banner when user details API fails but Order Summary is still available */}
                            {userDataError && (
                                <div style={{ marginBottom: '15px', padding: '12px', backgroundColor: '#fff3cd', border: '1px solid #ffc107', borderRadius: '4px', color: '#856404' }}>
                                    <strong>Warning:</strong> {userDataError}
                                </div>
                            )}
                            
                            {/* Personal Details - Auto-filled and Read-only */}
                            <h3 style={{ color: '#6b46c1', marginBottom: '15px', fontSize: '14px', fontWeight: 'bold', marginTop: 0 }}>Personal Details</h3>
                            
                            {/* LAN Number / Application ID */}
                            <div style={{ marginBottom: '20px', padding: '12px', backgroundColor: '#f0f4ff', borderRadius: '4px', border: '1px solid #d4d9f0' }}>
                                <p style={{ margin: 0, color: '#333', fontSize: '13px' }}>
                                    <strong>LAN Number / Application ID:</strong> {userData?.loan_acct_number || 'N/A'}
                                </p>
                            </div>

                            <div style={{ display: 'grid', gridTemplateColumns: window.innerWidth < 600 ? '1fr' : '1fr 1fr', gap: '12px', marginBottom: '20px' }}>
                                <div>
                                    <label style={{ fontWeight: 'bold', color: '#333', display: 'block', marginBottom: '8px', fontSize: '14px' }}>
                                        Full Name<span style={{ color: 'red' }}>*</span>
                                    </label>
                                    <input
                                        type="text"
                                        readOnly
                                        value={userData?.proposer_name || 'N/A'}
                                        style={{
                                            width: '100%',
                                            padding: '12px',
                                            border: '1px solid #ddd',
                                            borderRadius: '4px',
                                            backgroundColor: '#f5f5f5',
                                            color: '#333',
                                            boxSizing: 'border-box',
                                            fontSize: '14px',
                                            cursor: 'not-allowed'
                                        }}
                                    />
                                </div>
                                <div>
                                    <label style={{ fontWeight: 'bold', color: '#333', display: 'block', marginBottom: '8px', fontSize: '14px' }}>
                                        Email ID<span style={{ color: 'red' }}>*</span>
                                    </label>
                                    <input
                                        type="email"
                                        readOnly
                                        value={userData?.email || 'N/A'}
                                        style={{
                                            width: '100%',
                                            padding: '12px',
                                            border: '1px solid #ddd',
                                            borderRadius: '4px',
                                            backgroundColor: '#f5f5f5',
                                            color: '#333',
                                            boxSizing: 'border-box',
                                            fontSize: '14px',
                                            cursor: 'not-allowed'
                                        }}
                                    />
                                </div>
                            </div>

                            <div style={{ display: 'grid', gridTemplateColumns: window.innerWidth < 600 ? '1fr' : '1fr 1fr', gap: '12px', marginBottom: '20px' }}>
                                <div>
                                    <label style={{ fontWeight: 'bold', color: '#333', display: 'block', marginBottom: '6px', fontSize: '13px' }}>
                                        Mobile Number<span style={{ color: 'red' }}>*</span>
                                    </label>
                                    <input
                                        type="tel"
                                        readOnly
                                        value={userData?.mobilenumber || 'N/A'}
                                        style={{
                                            width: '100%',
                                            padding: '12px',
                                            border: '1px solid #ddd',
                                            borderRadius: '4px',
                                            backgroundColor: '#f5f5f5',
                                            color: '#333',
                                            boxSizing: 'border-box',
                                            fontSize: '14px',
                                            cursor: 'not-allowed'
                                        }}
                                    />
                                </div>
                                <div>
                                    <label style={{ fontWeight: 'bold', color: '#333', display: 'block', marginBottom: '8px', fontSize: '14px' }}>
                                        Gender<span style={{ color: 'red' }}>*</span>
                                    </label>
                                    <input
                                        type="text"
                                        readOnly
                                        value={userData?.gender || 'N/A'}
                                        style={{
                                            width: '100%',
                                            padding: '12px',
                                            border: '1px solid #ddd',
                                            borderRadius: '4px',
                                            backgroundColor: '#f5f5f5',
                                            color: '#333',
                                            boxSizing: 'border-box',
                                            fontSize: '14px',
                                            cursor: 'not-allowed'
                                        }}
                                    />
                                </div>
                            </div>

                            <div style={{ display: 'grid', gridTemplateColumns: window.innerWidth < 600 ? '1fr' : '1fr 1fr', gap: '12px', marginBottom: '20px' }}>
                                <div>
                                    <label style={{ fontWeight: 'bold', color: '#333', display: 'block', marginBottom: '6px', fontSize: '13px' }}>
                                        Date Of Birth<span style={{ color: 'red' }}>*</span>
                                    </label>
                                    <input
                                        type="text"
                                        readOnly
                                        value={userData?.proposer_dob ? new Date(userData.proposer_dob).toLocaleDateString() : 'N/A'}
                                        style={{
                                            width: '100%',
                                            padding: '12px',
                                            border: '1px solid #ddd',
                                            borderRadius: '4px',
                                            backgroundColor: '#f5f5f5',
                                            color: '#333',
                                            boxSizing: 'border-box',
                                            fontSize: '14px',
                                            cursor: 'not-allowed'
                                        }}
                                    />
                                </div>
                                <div style={{ visibility: 'hidden' }}>
                                    <label style={{ fontWeight: 'bold', color: '#333', display: 'block', marginBottom: '8px', fontSize: '14px' }}>
                                        Placeholder
                                    </label>
                                    <input type="text" style={{ width: '100%', padding: '12px' }} />
                                </div>
                            </div>
                        </div>

                        {/* Member 1 - Pre-filled and Read-only */}
                        <div style={{ marginBottom: '20px', padding: '15px', backgroundColor: '#fff', borderRadius: '4px', border: '1px solid #e0e0e0' }}>
                            <h5 style={{ color: '#333', marginBottom: '10px' }}>Member 1 (Primary)</h5>
                            <div style={{ marginBottom: '12px' }}>
                                <label style={{ fontWeight: 'bold', color: '#333', display: 'block', marginBottom: '5px', fontSize: '14px' }}>Name</label>
                                <input type="text" readOnly value={member1.name || 'N/A'} style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px', backgroundColor: '#f5f5f5', color: '#333', boxSizing: 'border-box', fontSize: '14px', cursor: 'not-allowed' }} />
                            </div>
                            <div style={{ marginBottom: '12px' }}>
                                <label style={{ fontWeight: 'bold', color: '#333', display: 'block', marginBottom: '5px', fontSize: '14px' }}>Phone Number</label>
                                <input type="tel" readOnly value={member1.phone || 'N/A'} style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px', backgroundColor: '#f5f5f5', color: '#333', boxSizing: 'border-box', fontSize: '14px', cursor: 'not-allowed' }} />
                            </div>
                            <div style={{ marginBottom: '12px' }}>
                                <label style={{ fontWeight: 'bold', color: '#333', display: 'block', marginBottom: '5px', fontSize: '14px' }}>Date of Birth</label>
                                <input type="text" readOnly value={formatMemberDob(member1.dob)} style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px', backgroundColor: '#f5f5f5', color: '#333', boxSizing: 'border-box', fontSize: '14px', cursor: 'not-allowed' }} />
                            </div>
                            <div style={{ marginBottom: '12px' }}>
                                <label style={{ fontWeight: 'bold', color: '#333', display: 'block', marginBottom: '5px', fontSize: '14px' }}>Relationship</label>
                                <input type="text" readOnly value={member1.relationship || 'N/A'} style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px', backgroundColor: '#f5f5f5', color: '#333', boxSizing: 'border-box', fontSize: '14px', cursor: 'not-allowed' }} />
                            </div>
                        </div>

                        {/* Member 2 - Pre-filled and Read-only */}
                        <div style={{ marginBottom: '20px', padding: '15px', backgroundColor: '#fff', borderRadius: '4px', border: '1px solid #e0e0e0' }}>
                            <h5 style={{ color: '#333', marginBottom: '10px' }}>Member 2 (Secondary)</h5>
                            <div style={{ marginBottom: '12px' }}>
                                <label style={{ fontWeight: 'bold', color: '#333', display: 'block', marginBottom: '5px', fontSize: '14px' }}>Name</label>
                                <input type="text" readOnly value={member2.name || 'N/A'} style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px', backgroundColor: '#f5f5f5', color: '#333', boxSizing: 'border-box', fontSize: '14px', cursor: 'not-allowed' }} />
                            </div>
                            <div style={{ marginBottom: '12px' }}>
                                <label style={{ fontWeight: 'bold', color: '#333', display: 'block', marginBottom: '5px', fontSize: '14px' }}>Phone Number</label>
                                <input type="tel" readOnly value={member2.phone || 'N/A'} style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px', backgroundColor: '#f5f5f5', color: '#333', boxSizing: 'border-box', fontSize: '14px', cursor: 'not-allowed' }} />
                            </div>
                            <div style={{ marginBottom: '12px' }}>
                                <label style={{ fontWeight: 'bold', color: '#333', display: 'block', marginBottom: '5px', fontSize: '14px' }}>Date of Birth</label>
                                <input type="text" readOnly value={formatMemberDob(member2.dob)} style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px', backgroundColor: '#f5f5f5', color: '#333', boxSizing: 'border-box', fontSize: '14px', cursor: 'not-allowed' }} />
                            </div>
                            <div style={{ marginBottom: '12px' }}>
                                <label style={{ fontWeight: 'bold', color: '#333', display: 'block', marginBottom: '5px', fontSize: '14px' }}>Relationship</label>
                                <input type="text" readOnly value={member2.relationship || 'N/A'} style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px', backgroundColor: '#f5f5f5', color: '#333', boxSizing: 'border-box', fontSize: '14px', cursor: 'not-allowed' }} />
                            </div>
                        </div>

                        {!showMember3 && packageData?.totalMembers >= 3 && (
                            <button onClick={() => setShowMember3(true)} style={{ width: '100%', padding: '12px', marginBottom: '20px', backgroundColor: '#f5f5f5', color: '#6b46c1', border: '2px dashed #6b46c1', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold', fontSize: '14px' }}>
                                + Add Member 3
                            </button>
                        )}

                        {/* Member 3 - Optional */}
                        {showMember3 && (
                            <div style={{ marginBottom: '20px', padding: '15px', backgroundColor: '#fff', borderRadius: '4px', border: '1px solid #e0e0e0' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                                    <h5 style={{ color: '#333', margin: 0 }}>Member 3</h5>
                                    <button onClick={() => { setShowMember3(false); setMember3({ name: '', phone: '', dob: '', relationship: '' }); }} style={{ background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer', color: '#999' }}>×</button>
                                </div>
                                <div style={{ marginBottom: '12px' }}>
                                    <label style={{ fontWeight: 'bold', color: '#333', display: 'block', marginBottom: '5px', fontSize: '14px' }}>Name</label>
                                    <input type="text" placeholder="Enter member name" value={member3.name} onChange={(e) => setMember3({ ...member3, name: e.target.value })} style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px', backgroundColor: '#fff', color: '#333', boxSizing: 'border-box', fontSize: '14px' }} />
                                </div>
                                <div style={{ marginBottom: '12px' }}>
                                    <label style={{ fontWeight: 'bold', color: '#333', display: 'block', marginBottom: '5px', fontSize: '14px' }}>Phone Number</label>
                                    <input type="tel" placeholder="Enter phone number" value={member3.phone} onChange={(e) => setMember3({ ...member3, phone: e.target.value })} style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px', backgroundColor: '#fff', color: '#333', boxSizing: 'border-box', fontSize: '14px' }} />
                                </div>
                                <div style={{ marginBottom: '12px' }}>
                                    <label style={{ fontWeight: 'bold', color: '#333', display: 'block', marginBottom: '5px', fontSize: '14px' }}>Date of Birth</label>
                                    <input type="date" value={member3.dob} onChange={(e) => setMember3({ ...member3, dob: e.target.value })} style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px', backgroundColor: '#fff', color: '#333', boxSizing: 'border-box', fontSize: '14px' }} />
                                </div>
                                <div style={{ marginBottom: '12px' }}>
                                    <label style={{ fontWeight: 'bold', color: '#333', display: 'block', marginBottom: '5px', fontSize: '14px' }}>Relationship</label>
                                    <select value={member3.relationship} onChange={(e) => setMember3({ ...member3, relationship: e.target.value })} style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px', backgroundColor: '#fff', color: '#333', boxSizing: 'border-box', fontSize: '14px' }}>
                                        <option value="">Select relationship</option>
                                        <option value="Spouse">Spouse</option>
                                        <option value="Child">Child</option>
                                        <option value="Parent">Parent</option>
                                        <option value="Sibling">Sibling</option>
                                        <option value="Other">Other</option>
                                    </select>
                                </div>
                            </div>
                        )}

                        {!showMember4 && packageData?.totalMembers >= 4 && (
                            <button onClick={() => setShowMember4(true)} style={{ width: '100%', padding: '12px', marginBottom: '20px', backgroundColor: '#f5f5f5', color: '#6b46c1', border: '2px dashed #6b46c1', borderRadius: '4px', cursor: 'pointer', fontWeight: 'bold', fontSize: '14px' }}>
                                + Add Member 4
                            </button>
                        )}

                        {showMember4 && (
                            <div style={{ marginBottom: '20px', padding: '15px', backgroundColor: '#fff', borderRadius: '4px', border: '1px solid #e0e0e0' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                                    <h5 style={{ color: '#333', margin: 0 }}>Member 4</h5>
                                    <button onClick={() => { setShowMember4(false); setMember4({ name: '', phone: '', dob: '', relationship: '' }); }} style={{ background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer', color: '#999' }}>×</button>
                                </div>
                                <div style={{ marginBottom: '12px' }}>
                                    <label style={{ fontWeight: 'bold', color: '#333', display: 'block', marginBottom: '5px', fontSize: '14px' }}>Name</label>
                                    <input type="text" placeholder="Enter member name" value={member4.name} onChange={(e) => setMember4({ ...member4, name: e.target.value })} style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px', backgroundColor: '#fff', color: '#333', boxSizing: 'border-box', fontSize: '14px' }} />
                                </div>
                                <div style={{ marginBottom: '12px' }}>
                                    <label style={{ fontWeight: 'bold', color: '#333', display: 'block', marginBottom: '5px', fontSize: '14px' }}>Phone Number</label>
                                    <input type="tel" placeholder="Enter phone number" value={member4.phone} onChange={(e) => setMember4({ ...member4, phone: e.target.value })} style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px', backgroundColor: '#fff', color: '#333', boxSizing: 'border-box', fontSize: '14px' }} />
                                </div>
                                <div style={{ marginBottom: '12px' }}>
                                    <label style={{ fontWeight: 'bold', color: '#333', display: 'block', marginBottom: '5px', fontSize: '14px' }}>Date of Birth</label>
                                    <input type="date" value={member4.dob} onChange={(e) => setMember4({ ...member4, dob: e.target.value })} style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px', backgroundColor: '#fff', color: '#333', boxSizing: 'border-box', fontSize: '14px' }} />
                                </div>
                                <div style={{ marginBottom: '12px' }}>
                                    <label style={{ fontWeight: 'bold', color: '#333', display: 'block', marginBottom: '5px', fontSize: '14px' }}>Relationship</label>
                                    <select value={member4.relationship} onChange={(e) => setMember4({ ...member4, relationship: e.target.value })} style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px', backgroundColor: '#fff', color: '#333', boxSizing: 'border-box', fontSize: '14px' }}>
                                        <option value="">Select relationship</option>
                                        <option value="Spouse">Spouse</option>
                                        <option value="Child">Child</option>
                                        <option value="Parent">Parent</option>
                                        <option value="Sibling">Sibling</option>
                                        <option value="Other">Other</option>
                                    </select>
                                </div>
                            </div>
                        )}

                        {/* Order Summary Section */}
                        <div style={{ padding: '15px', backgroundColor: '#fff', borderRadius: '4px', border: '1px solid #e0e0e0', marginBottom: '20px' }}>
                            <h3 style={{ color: '#6b46c1', marginBottom: '15px', fontSize: '14px', fontWeight: 'bold', marginTop: 0 }}>Order Summary</h3>
                            
                            {/* Membership Name - From package API */}
                            <h4 style={{ color: '#6b46c1', marginBottom: '8px', fontSize: '16px', fontWeight: 'bold' }}>
                                {packageData?.packageName || userData?.packageName || 'N/A'}
                            </h4>

                            {/* Membership Details - From package API */}
                            <div style={{ marginBottom: '15px', paddingBottom: '15px', borderBottom: '1px solid #e0e0e0' }}>
                                <p style={{ marginBottom: '8px', color: '#333', fontSize: '13px' }}>
                                    <strong>Total members allowed:</strong> <span style={{ float: 'right' }}>
                                        {packageData?.totalMembers || 'N/A'}
                                    </span>
                                </p>
                                <p style={{ color: '#333', fontSize: '13px' }}>
                                    <strong>Membership Tenure:</strong> <span style={{ float: 'right' }}>
                                        {packageData?.tenure || 'N/A'}
                                    </span>
                                </p>
                            </div>

                            {/* Product Benefits - From package API */}
                            <div style={{ marginBottom: '20px' }}>
                                <h5 style={{ color: '#333', marginBottom: '12px', fontSize: '13px', fontWeight: 'bold' }}>
                                    Benefits available every year of membership:
                                </h5>
                                <ol style={{ color: '#666', fontSize: '12px', lineHeight: '1.6', paddingLeft: '18px', margin: 0 }}>
                                    {(() => {
                                        const benefits = packageData?.benefits;
                                        if (Array.isArray(benefits) && benefits.length > 0) {
                                            return benefits.map((benefit, idx) => <li key={idx}>{benefit}</li>);
                                        }
                                        return <li>N/A</li>;
                                    })()}
                                </ol>
                            </div>

                            {/* Price Section - Inclusive of Tax */}
                            <div style={{
                                background: '#f9f9f9',
                                padding: '15px',
                                borderRadius: '8px',
                                marginBottom: '20px'
                            }}>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center'
                                }}>
                                    <div>
                                        <span style={{ color: '#6b46c1', fontSize: '16px', fontWeight: 'bold' }}>Membership Fee:</span>
                                        <p style={{ color: '#999', fontSize: '11px', margin: '5px 0 0 0' }}>
                                            (Inclusive of 18% Tax)
                                        </p>
                                    </div>
                                    <span style={{ color: '#4caf50', fontSize: '18px', fontWeight: 'bold' }}>₹ {(userData?.discountedPrice || packageData?.price || 0).toLocaleString()}</span>
                                </div>
                            </div>
                        </div>
                        
                        {/* Separate Terms Checkboxes */}
                        <div style={{ marginBottom: '15px' }}>
                            <label style={{ display: 'flex', alignItems: 'flex-start', cursor: 'pointer', marginBottom: '10px' }}>
                                <input
                                    type="checkbox"
                                    checked={productTermsAccepted}
                                    onChange={(e) => setProductTermsAccepted(e.target.checked)}
                                    style={{
                                        marginRight: '8px',
                                        marginTop: '2px',
                                        cursor: 'pointer',
                                        width: '16px',
                                        height: '16px',
                                        minWidth: '16px'
                                    }}
                                />
                                <span style={{ color: '#333', fontSize: '12px', lineHeight: '1.4' }}>
                                    I have read and accepted{' '}
                                    <button
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setShowProductTermsModal(true);
                                        }}
                                        style={{
                                            background: 'none',
                                            border: 'none',
                                            color: '#6b46c1',
                                            textDecoration: 'underline',
                                            cursor: 'pointer',
                                            padding: 0,
                                            font: 'inherit',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        Medibuddy vHealth Gold membership terms and conditions
                                    </button>
                                </span>
                            </label>
                            <label style={{ display: 'flex', alignItems: 'flex-start', cursor: 'pointer' }}>
                                <input
                                    type="checkbox"
                                    checked={medibuddyTermsAccepted}
                                    onChange={(e) => setMedibuddyTermsAccepted(e.target.checked)}
                                    style={{
                                        marginRight: '8px',
                                        marginTop: '2px',
                                        cursor: 'pointer',
                                        width: '16px',
                                        height: '16px',
                                        minWidth: '16px'
                                    }}
                                />
                                <span style={{ color: '#333', fontSize: '12px', lineHeight: '1.4' }}>
                                    I have read and accepted the{' '}
                                    <button
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setShowMedibuddyTermsModal(true);
                                        }}
                                        style={{
                                            background: 'none',
                                            border: 'none',
                                            color: '#6b46c1',
                                            textDecoration: 'underline',
                                            cursor: 'pointer',
                                            padding: 0,
                                            font: 'inherit',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        Terms of Use given by Medibuddy vHealth
                                    </button>
                                </span>
                            </label>
                        </div>

                        {/* Error Message */}
                        {error && (
                            <div style={{
                                backgroundColor: '#f8d7da',
                                color: '#721c24',
                                padding: '10px',
                                borderRadius: '4px',
                                border: '1px solid #f5c6cb',
                                marginBottom: '15px',
                                fontSize: '12px'
                            }}>
                                {error}
                            </div>
                        )}

                        {/* Submit Button */}
                        <button
                            onClick={handlePayNow}
                            disabled={paymentLoading || !productTermsAccepted || !medibuddyTermsAccepted}
                            style={{
                                width: '100%',
                                padding: window.innerWidth < 600 ? '12px' : '14px',
                                backgroundColor: (paymentLoading || !productTermsAccepted || !medibuddyTermsAccepted) ? '#ccc' : '#6b46c1',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                fontSize: window.innerWidth < 600 ? '14px' : '16px',
                                fontWeight: 'bold',
                                cursor: (paymentLoading || !productTermsAccepted || !medibuddyTermsAccepted) ? 'not-allowed' : 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '8px'
                            }}
                        >
                            {paymentLoading ? (
                                <>
                                    <CircularProgress size={20} color="inherit" />
                                    Processing...
                                </>
                            ) : (
                                'Pay Now >'
                            )}
                        </button>
                    </Grid>
                </Grid>
            </Container>

            {/* Product Terms Modal */}
            {showProductTermsModal && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 1000
                }}>
                    <div style={{
                        backgroundColor: 'white',
                        borderRadius: '8px',
                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
                        width: '90%',
                        maxWidth: '600px',
                        maxHeight: '80vh',
                        display: 'flex',
                        flexDirection: 'column'
                    }}>
                        <div style={{
                            padding: '20px',
                            borderBottom: '1px solid #e0e0e0',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}>
                            <h2 style={{ margin: 0, color: '#333' }}>Medibuddy vHealth Gold membership terms and conditions</h2>
                            <button
                                onClick={() => setShowProductTermsModal(false)}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    fontSize: '24px',
                                    cursor: 'pointer',
                                    color: '#666'
                                }}
                            >
                                ×
                            </button>
                        </div>

                        <div style={{
                            padding: '20px',
                            overflowY: 'auto',
                            flex: 1,
                            color: '#333',
                            lineHeight: '1.6',
                            fontSize: '13px'
                        }}>
                            {/* <h4 style={{ color: '#333', marginTop: '0' }}>Application Form</h4>
                            <h4 style={{ color: '#333' }}>Group Safeguard Insurance</h4> */}
                            <p>
                                I am fully aware that the Access Health Program is being arranged to me by SMFG India Credit Co. Ltd. ("SMICC") at a discounted rate regarding the initial Access Health Program Product Charges and any applicable renewal or other fees shall be required to be paid by me as specified in the terms and conditions to be provided to me by IHO along with the Access Health Program. I understand that IHO is not an insurance company and is not involved in the sale or otherwise of insurance products. Further, I hereby declare that I have understood the benefits which shall be available to me as a holder of the Access Health Program and agree that the use of such Access benefits of the Health Program by me shall be subject to the terms and conditions to be provided to me along with the Access Health Program as well as the terms and conditions stated on the website of IHO (vhealth.io). I further understand that the Access Health Program is being offered to me by IHO, and SMICC shall not be responsible in any way regarding the services provided or any other terms & conditions of the Access Health Program. I hereby authorize SMICC to deduct appropriate Access Health Program charges from the loan amount and pay the amount to IHO.I also authorize SMICC to disclose, from time to time, any information relating to my Loan account to IHO as SMICC may deem fit. I hereby agree that if for any reason whatsoever if the required charges are not deducted /recovered and paid by SMICC to IHO, no liability will be attached to SMICC, and the Access Health Program shall not be provided to me till such payment is made to IHO. In the event of cancellation of the IHO card within the free-look period provided by IHO, the fee amount deducted shall be refunded on request/maturity of the loan after adjusting all amounts and charges due by me/us under the SMICC Loan Agreement.
                                <br /><br />
                                For intimation of claim or any clarification with respect to the policy conditions, please contact ICICI Lombard insurance company Ltd at the ihealthcare@icicilombard.com, customersupport@icicilombard.com or call at 1800 2666.
                            </p>

                            <h4 style={{ color: '#333' }}>Self-declaration in relation to group safeguard insurance policy forming part of 'MediBuddy vHealth Gold'.</h4>
                            <ol style={{ paddingLeft: '20px' }}>
                                <li>I understand that Indian Health Organisation Private Limited ('IHO') is engaged in the service of providing various health care benefits through a membership system and for that purpose IHO issues membership with wellness cards/health cards to its members.</li>
                                <li>I understand that wellness membership is the primary product of IHO. IHO is not an insurance company, third party administrator or insurance broker/agent and is not otherwise regulated by Insurance Regulatory and Development Authority of India. The group insurance policy offered by ICICI Lombard insurance company Ltd. is being bundled along with the 'MediBuddy vHealth Gold' package as an add-on benefit. IHO offers membership plans with similar benefits without insurance cover as well. I as a prospective member of IHO have the option to choose a membership plan with or without insurance cover as per its requirements.</li>
                                <li>I understand that the insurance policy is provided by ICICI Lombard insurance company Ltd. to me. Any grievance arising out of claims and/or services related to the insurance cover shall be directly pursued with ICICI Lombard insurance company Ltd. IHO/ SMICC shall not be liable for any such claims.</li>
                                <li>I understand that the commencement of insurance coverage will start from the date set out in the certificate of insurance. ICICI Lombard insurance company Ltd. may reject any application for insurance in its sole discretion or based on its inability to obtain underwriting and IHO/SMICC shall not be liable for the same. It is hereby clarified to me that my purchase of IHO membership does not guarantee entitlement to the insurance policy by ICICI Lombard insurance company Ltd.</li>
                                <li>I understand that IHO/SMICC would not be liable for a deficiency in the services of ICICI Lombard insurance company Ltd., in any case whatsoever.</li>
                                <li>I understand that the insurance coverage would stand automatically terminated on expiry of my IHO membership in the enrollment certificate or earlier termination of the membership owing to a misrepresentation/fraud/suppression of material facts/non-cooperation by myself and/or any of my family member enrolled for the membership.</li>
                                <li>I understand that the decision of ICICI Lombard insurance company Ltd. regarding adjudication of claims will be final and binding.</li>
                                <li>I understand that IHO does not charge any separate fees or commission for making this insurance program available to me and/or any of my family members enrolled for the membership.</li>
                                <li>I understand that no cancellation shall be carried out if a valid request is not made by me within 15 days of receipt of IHOs vHealth Gold Plan's welcome pack. For detailed terms and conditions, please refer vhealth.io.</li>
                            </ol>
                        </div>

                        <div style={{
                            padding: '20px',
                            borderTop: '1px solid #e0e0e0',
                            display: 'flex',
                            gap: '10px',
                            justifyContent: 'flex-end'
                        }}>
                            <button
                                onClick={() => setShowProductTermsModal(false)}
                                style={{
                                    padding: '10px 20px',
                                    backgroundColor: '#f0f0f0',
                                    color: '#333',
                                    border: '1px solid #ddd',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontWeight: 'bold'
                                }}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* MediBuddy Terms Modal */}
            {showMedibuddyTermsModal && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 1000
                }}>
                    <div style={{
                        backgroundColor: 'white',
                        borderRadius: '8px',
                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
                        width: '90%',
                        maxWidth: '600px',
                        maxHeight: '80vh',
                        display: 'flex',
                        flexDirection: 'column'
                    }}>
                        <div style={{
                            padding: '20px',
                            borderBottom: '1px solid #e0e0e0',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}>
                            <h2 style={{ margin: 0, color: '#333' }}>Terms of Use given by Medibuddy vHealth</h2>
                            <button
                                onClick={() => setShowMedibuddyTermsModal(false)}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    fontSize: '24px',
                                    cursor: 'pointer',
                                    color: '#666'
                                }}
                            >
                                ×
                            </button>
                        </div>

                        <div style={{
                            padding: '20px',
                            overflowY: 'auto',
                            flex: 1,
                            color: '#333',
                            lineHeight: '1.6',
                            fontSize: '13px'
                        }}>
                            <TermsOfUseContent />
                        </div>

                        <div style={{
                            padding: '20px',
                            borderTop: '1px solid #e0e0e0',
                            display: 'flex',
                            gap: '10px',
                            justifyContent: 'flex-end'
                        }}>
                            <button
                                onClick={() => setShowMedibuddyTermsModal(false)}
                                style={{
                                    padding: '10px 20px',
                                    backgroundColor: '#f0f0f0',
                                    color: '#333',
                                    border: '1px solid #ddd',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontWeight: 'bold'
                                }}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

const styles = (theme) => ({
    container: {
        padding: theme.spacing(3)
    }
});

export default withStyles(styles)(SelfFundComponent);
